module.exports = __webpack_public_path__ + "img/img-f91532.jpg";